module.exports = __webpack_public_path__ + "static/img/UTSC老师_May.5c25282.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC老师_May.png
// module id = dlP0
// module chunks = 0